import { Injectable } from '@angular/core'
import { FormControl } from '@angular/forms'
import { BackService } from '../services/back.service'
import { Api } from '../store'

@Injectable()
export class AsyncValidator {

  private debouncer: any

  constructor(private bs: BackService) {}

  public checkBarcode = (c: FormControl) => {
    clearTimeout(this.debouncer)
    return new Promise(resolve => {
      this.debouncer = setTimeout(() => {
        this.bs.post(Api.import.sku.checkBarcode, { barcode: c.value }, null).subscribe(
          good => {
            if (good) {
              resolve(null)
            } else {
              resolve({ barcodeExists: true })
            }
          },
          error => {
            resolve({ barcodeExists: true })
          }
        )
      }, 1000)
    })
  }

  public checkDbAvailable = (codeControl: FormControl) => (c: FormControl) => {
    clearTimeout(this.debouncer)
    return new Promise(resolve => {
      this.debouncer = setTimeout(() => {
        if (!codeControl.value) {
          return resolve(null)
        }
        this.bs.post(Api.master.checkDbAvailable, { db: c.value, code: codeControl.value }, null).subscribe(
          good => {
            if (good) {
              resolve(null)
            } else {
              resolve({ dbExists: true })
            }
          },
          error => {
            resolve({ dbExists: true })
          }
        )
      }, 1000)
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/validators/async.validator.ts